import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const useStyles = makeStyles(() => ({
    customStyles: {
        "&.MuiIconButton-root": {
            padding: 0,
            marginTop: "-0.5rem",
        },
    },
    menuPaper: {
        border: "1px solid #DADBDE",
        width: "17.25rem",
        top: "1rem",
        "&:hover": {
            border: "1px solid black",
        },
    },
    avatarWrapperWithBorder: {
        border: "1px solid " + globalThis.config.colors.black,
        padding: "0.2rem",
    },
    avatarWrapperWithoutBorder: {
        border: "none",
        padding: "0.2rem",
    },
}));

export const TextWrapper = styled.div`
    margin: auto 0.5rem;
    height: 1.75rem;
    padding-top: 0.1rem;
`;

export const UserWrapper = styled.div`
    display: flex;
`;

export const UserWrapperCol1 = styled.div`
    width: 1rem;
    margin: 0.7rem 0.1rem;
`;

export const UserWrapperCol2 = styled.div`
    margin: 0.3rem 2.2rem;
    height: 4rem;
`;

export const AvatarWrapper = styled.div`
    margin: auto 1rem;
    float: left;
`;

export const UserFullNameWrapper = styled.div`
    margin: auto 1rem;
    color: ${globalThis.config.colors.black};
    font-family: ${globalThis.config.fonts.families.medium};
    font-size: ${globalThis.config.fonts.sizes.small};
`;

export const UserTitleWrapper = styled.div`
    margin: auto 1rem;
    color: ${globalThis.config.colors.gray2};
    font-family: ${globalThis.config.fonts.families.light};
    font-size: ${globalThis.config.fonts.sizes.xsmall};
`;

export const UserOfficeWrapper = styled.div`
    margin: auto 1rem;
    color: ${globalThis.config.colors.gray2};
    font-family: ${globalThis.config.fonts.families.light};
    font-size: ${globalThis.config.fonts.sizes.xsmall};
`;

export const MainAvatarWrapper = styled.div`
    border-radius: 50%;
    width: 2.75rem;
    height: 2.75rem;
    padding: 0.2rem 0 0 0.2rem;
`;
